import {
  isCoordinateOrigin,
  parseCoordinateLocationJson,
} from './coordinate-location-payload.util';

export function extractLocationSearchValue(exportFilter: any[]): string | null {
  const payload = exportFilter?.[0]?.payload;
  if (!payload?.length) {
    return null;
  }
  const entry = payload.find((d: { attribute?: string }) => d.attribute === 'location_search');
  return entry?.value ?? null;
}

export function isCoordinateLocationSearchValue(value: string | null | undefined): boolean {
  if (!value) {
    return false;
  }
  return isCoordinateOrigin(parseCoordinateLocationJson(value));
}
